<template lang="pug">
b-modal#textBtnModal.modal.fade(
  @close="showModal = false",
  centered,
  hide-footer="",
  :title="title",
  tabindex="-1",
  aria-labelledby="textBtnModal",
  aria-hidden="true"
)
  p(v-html="content")
  button.btn.btn-primary.btn-block(@click="onBtnClick") {{ btn }}
</template>

<script>
export default {
  name: "DialogTextBtn",
  props: {
    title: String,
    content: String,
    btn: String,
  },
  methods: {
    onBtnClick() {
      this.$emit("onDialogTextBtnClick");
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-header {
  border: 0;
  padding-bottom: 0;
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
